"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CognitiveIconPicker;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _InputBase = _interopRequireDefault(require("@mui/material/InputBase/InputBase.js"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _Select = _interopRequireDefault(require("@mui/material/Select/Select.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _lodash = require("lodash");
var _axios = _interopRequireDefault(require("axios"));
var _swr = _interopRequireDefault(require("swr"));
var _reactWindow = require("react-window");
var _CognitiveIcon = _interopRequireDefault(require("./CognitiveIcon"));
var _helpers = require("../utils/helpers");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const scrollHeight = 300;
const iconsPerRow = 9;
const width = iconsPerRow * 30 + 12; // icon width plus padding
const rowHeight = 30;
function CognitiveIconPicker({
  onSelect,
  iconTypes
}) {
  const icons = useIcons(iconTypes);
  const [searchString, setSearchString] = (0, _react.useState)('');
  const [selectedCategory, setSelectedCategory] = (0, _react.useState)(allOptionValue);
  const filteredIcons = icons?.filter(i => i.title.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()));
  const categoryAndTypes = (0, _react.useMemo)(() => {
    if (!icons) return;
    const categoryAndTypes = (0, _lodash.uniqWith)(icons.map(i => ({
      type: i.type,
      category: i.category
    })), _lodash.isEqual);
    return categoryAndTypes;
  }, [icons]);
  const selectOptions = makeSelectOptions(categoryAndTypes);
  const categoriesWithIcons = categoryAndTypes?.filter(({
    type,
    category
  }) => {
    if (selectedCategory === allOptionValue) return true;
    const split = selectedCategory.split('-');
    if (type !== split[0]) return false;
    return !split[1] || category === split[1];
  }).map(({
    type,
    category
  }) => ({
    type,
    category,
    icons: filteredIcons?.filter(i => i.type === type && i.category === category) ?? []
  })).filter(c => c.icons && c.icons.length > 0);
  const rows = categoriesWithIcons?.reduce((acc, cur) => {
    const {
      category,
      icons
    } = cur;
    const title = style => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      style: style,
      height: rowHeight,
      display: "flex",
      flexDirection: "column-reverse",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        children: category
      })
    });
    const iconChunks = (0, _lodash.chunk)(icons, iconsPerRow);
    const iconRows = iconChunks.map(chunk => {
      return style => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        style: style,
        display: "flex",
        height: rowHeight,
        children: chunk.map(icon => /*#__PURE__*/(0, _jsxRuntime.jsx)(CognitiveIconButton, {
          ...icon,
          onClick: () => onSelect(icon)
        }, icon.file))
      });
    });
    return [...acc, title, ...iconRows];
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: width,
    height: scrollHeight,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: "flex",
      alignItems: "center",
      gap: 1,
      borderBottom: "2px solid grey",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Search.default, {
        fontSize: "small"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        flex: 1,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase.default, {
          autoFocus: true,
          fullWidth: true,
          placeholder: "Search",
          value: searchString,
          onFocus: e => e.target.select(),
          onChange: e => setSearchString(e.target.value)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
        disableUnderline: true,
        sx: {
          width: '130px'
        },
        label: "Category",
        value: selectedCategory,
        onChange: e => setSelectedCategory(e.target.value),
        children: selectOptions?.map(o => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
            sx: {
              pl: o.type === 'type' ? 1 : 3
            },
            value: o.value,
            children: o.label
          }, `${o.type}${o.value}`);
        })
      })]
    }), icons ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactWindow.FixedSizeList, {
      width: "100%",
      height: scrollHeight,
      itemSize: rowHeight,
      itemCount: rows?.length,
      children: ({
        index,
        style
      }) => rows?.[index](style)
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {})
    })]
  });
}
const allOptionValue = '_empty-option';
function makeSelectOptions(categoryAndTypes) {
  if (!categoryAndTypes) return;
  let currentType;
  const options = categoryAndTypes.reduce((acc, {
    type,
    category
  }) => {
    if (type !== currentType) {
      currentType = type;
      acc = [...acc, {
        type: 'type',
        value: type,
        label: (0, _lodash.capitalize)(type)
      }];
    }
    acc = [...acc, {
      type: 'category',
      value: `${type}-${category}`,
      label: (0, _lodash.capitalize)(category)
    }];
    return acc;
  }, []);
  const allOption = {
    type: 'type',
    value: allOptionValue,
    label: 'Category'
  };
  return [allOption, ...options];
}
function CognitiveIconButton({
  title,
  onClick,
  ...icon
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: title,
    placement: "top",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      size: "small",
      onClick: onClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CognitiveIcon.default, {
        icon: icon,
        fontSize: "small"
      })
    })
  });
}
function useIcons(iconTypes) {
  const swrOptions = {
    revalidateOnFocus: false,
    errorRetryCount: 2,
    dedupingInterval: 60000
  };
  const {
    data
  } = (0, _swr.default)('tada-icons', getIcons, swrOptions);
  function getIconTypes(iconTypes) {
    const types = [];
    for (let iconType in iconTypes) {
      switch (iconTypes[iconType]) {
        case 'tada':
          types.push(getTadaIcons());
          break;
        case 'google':
          types.push(getGoogleIcons());
          break;
        default:
          break;
      }
    }
    return types;
  }
  function getIcons() {
    let _iconTypes = [getTadaIcons(), getGoogleIcons()];
    if (Boolean(iconTypes)) {
      _iconTypes = getIconTypes(iconTypes);
    }
    return Promise.all(_iconTypes).then(res => res.reduce((ac, cur) => [...ac, ...cur]));
  }
  function getTadaIcons() {
    return _axios.default.get('https://api.tadanow.com/icons').then(({
      data
    }) => {
      return Object.keys(data).reduce((acc, category) => {
        const icons = data[category].map(file => ({
          type: 'tada',
          category,
          file: `${category}/${file}`,
          title: (0, _lodash.capitalize)(file.replace(/\.[^/.]+$/, ''))
        }));
        return [...acc, ...icons];
      }, []);
    });
  }
  function getGoogleIcons() {
    return _axios.default.get((0, _helpers.pathToPublicFile)('google-icons.json')).then(({
      data
    }) => {
      return data.map(icon => ({
        type: 'google',
        category: icon.category,
        file: icon.file,
        title: (0, _lodash.capitalize)(icon.file.replace(/_/g, ' '))
      }));
    });
  }
  return data;
}